// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"37958af7","693":"f7cfe6aa","845":"95718d95","983":"6f390ef2"}[chunkId] + ".chunk.js";
};